import con from "../../../connection";

const path = '/version';

const version = (url: string) => (versionNumber: string) => ({
  get: () => con.get(url + path + "/" + versionNumber, {})
})

export default version;